import React, { useEffect, useState } from "react";
import "./DropdownMessage.scss";
import Dropdown from "../Dropdown";
import AppMessageElement from "../AppMessageElement";
import { List } from "devextreme-react";

import "./DropdownMessage.scss";
import ScrollableContent from "../ScrollableContent";
import { isArrayEmpty } from "../../utils/isArrayEmpty";
import moment from "moment";

const DropdownMessage = (props) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    let data = [];
    if (Array.isArray(props.messages) && !isArrayEmpty(props.messages)) {
      props.messages.forEach((message) => {
        let key = moment(message.creationTime).format("YYYY/MM/DD");
        let selectedItem = data.filter((x) => x.key === key);
        if (selectedItem.length === 0) {
          data.push({
            key: key,
            items: [message],
          });
        } else {
          selectedItem[0].items.push(message);
        }
      });
      setData(data);
    }
  }, [props.messages]);
  return (
    <Dropdown isExpanded={props.isExpanded} onRef={props.onRef}>
      <div className="app-message-content">
        <ScrollableContent>
          <List
            dataSource={data}
            height="inherit"
            itemRender={AppMessageElement}
            scrollByContent={true}
            scrollByThumb={true}
            pageLoadMode="scrollBottom"
            grouped={true}
            // collapsibleGroups={true}
          />
        </ScrollableContent>
      </div>
    </Dropdown>
  );
};
export default DropdownMessage;
